import { graphql } from "~/gql";

export const UPDATE_SETTINGS = graphql(/* GraphQL */ `
  mutation updateSettings($id: Float!, $data: SettingsUpdateInput!) {
    updateSettings(id: $id, data: $data) {
      ...SettingsParts
    }
  }
`);
